import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('roles.routes.index'),
        name: i18n.t('roles.routes.index'),
        component: () =>
            import(/* webpackChunkName: "roles" */ '@/views/roles/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('roles.breadcrumbs.index'),
                    to: { name: i18n.t('roles.routes.index') },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('roles.routes.create'),
        name: i18n.t('roles.routes.create'),
        component: () =>
            import(/* webpackChunkName: "roles" */ '@/views/roles/Create.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('roles.breadcrumbs.index'),
                    to: { name: i18n.t('roles.routes.index') },
                    disable: false,
                },
                {
                    text: i18n.t('roles.breadcrumbs.create'),
                    to: { name: i18n.t('roles.routes.create') },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('roles.routes.edit') + '/:id',
        name: i18n.t('roles.routes.edit'),
        component: () =>
            import(/* webpackChunkName: "roles" */ '@/views/roles/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('roles.breadcrumbs.index'),
                    to: { name: i18n.t('roles.routes.index') },
                    disable: false,
                },
                {
                    text: i18n.t('roles.breadcrumbs.edit'),
                    to: { name: i18n.t('roles.routes.edit') },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
